import React, { createContext, ReactNode, useContext } from 'react';

export interface IDeviceInfo {
  isMobile: boolean;
  setIsMobile: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IDeviceProps {
  value: IDeviceInfo;
  children: ReactNode;
}

export const DeviceContext = createContext<IDeviceInfo | null>(null);

export function useDevice() {
  const ctx = useContext(DeviceContext) as IDeviceInfo;
  return ctx;
}

export default function DeviceProvider({ value, children }: IDeviceProps): JSX.Element {
  return <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>;
}
